import React from 'react';
import PropTypes from 'prop-types';

/**
 * A question-mark icon whose text appears on hover and on keyboard focus.
 *
 * Deliberately NOT the browser's native `title` attribute: StatCard's built-in
 * tooltip prop uses one, and on this page it never appeared for the reviewer -
 * native tooltips also need about a second of hover and ignore clicks, which
 * reads as broken. This renders its own bubble, so it is instant and styled.
 */
const HelpTip = ({ label, text }) => (
	<span
		className="dsm-help"
		tabIndex={0}
		role="note"
		aria-label={`What "${label}" means: ${text}`}
	>
		<i className="bi bi-question-circle" aria-hidden="true" />
		<span className="dsm-help-bubble" role="tooltip">
			{text}
		</span>
	</span>
);

HelpTip.propTypes = {
	/** The thing being explained, used for the accessible name. */
	label: PropTypes.string.isRequired,
	/** The explanation itself. */
	text: PropTypes.string.isRequired,
};

export default HelpTip;
